import type { Components } from '@mildang/mui';
import type { Theme } from '@mildang/mui';

const createAppbar = (theme: Theme): Components => ({
  MuiToolbar: {
    styleOverrides: {
      root: {
        // paddingLeft: 16,
        // paddingRight: 16,
        [theme.breakpoints.up('sm')]: {
          paddingLeft: 16,
          paddingRight: 16,
        },
      },
    },
  },
  MuiAppBar: {
    defaultProps: {
      elevation: 0,
    },
    styleOverrides: {
      root: {
        borderRadius: 0,
      },
      colorDefault: {
        background: theme.palette.background.default,
      },
    },
  },
});

export default createAppbar;
